/* Redux */
import { AnyAction, Dispatch } from 'redux';
import { tipsActions } from '../../../store/tips/actions';

/* Interfaces */
import { PaymentProcessor } from './PaymentProcessor';
import { AnalyticsClient } from '../../../analytics/Client';
import { StoreType, StoreTypesReversed } from './store_types';
import { PurchaseStatus } from '../../Shops/shared/__providers__/PurchaseStatusProvider';

/* Services */
import { requestFreeTipPurchase } from '../../../api/payments/Tickets/tipPayments';

/* Utils */
import { delay } from '../utils/delay';

export class TicketPaymentProcessor extends PaymentProcessor {
  protected options: {
    ticketID: string;
    tipID: string;
  };

  constructor(
    dispatcher: Dispatch<AnyAction>,
    loader: (load: boolean) => void,
    analyticsClient: AnalyticsClient,
    setPurchaseStatus: (status: PurchaseStatus) => void,
    tipID: string,
    ticketID: string,
  ) {
    super(dispatcher, loader, analyticsClient, setPurchaseStatus);

    this.options = { ticketID, tipID };
  }

  public async processPayment(store: StoreType): Promise<any> {
    this.loader(true);

    try {
      if (store === StoreTypesReversed.TipPurchase) {
        const response: any = await requestFreeTipPurchase(
          this.options.tipID,
          this.options.ticketID,
        );

        if (response.tip) {
          return this.finishPayment();
        }
      }
    } catch (error: unknown) {
      this.handleError(error as Error);
    }
  }

  public async finishPayment(): Promise<any> {
    this.setPurchaseStatus(PurchaseStatus.COMPLETED);

    await delay(1500);

    this.dispatcher(tipsActions.tipProductRequestAction(this.options.tipID));
    this.loader(false);
  }

  public handleError(error: Error) {
    console.error(error.message);

    this.setPurchaseStatus(PurchaseStatus.FAILED);
    this.loader(false);
  }
}
